/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Collapse,
  Divider,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import React, { useState } from 'react'

import { getTranslate } from '../../../../localization'
import { RoomPriceDetails } from '../../../../types/bookingDetails'
import { Currency } from '../../../../types/currency'
import RoomStayPriceDetails from './RoomStayPriceDetails'
import { useStyles } from './styles/index.styles'

type AmountDetailsProps = {
  roomsPriceDetails: RoomPriceDetails[] | undefined
  curruncy: Currency
}

const AmountDetails: React.FC<AmountDetailsProps> = ({
  roomsPriceDetails,
  curruncy
}: AmountDetailsProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [showDetails, setShowDetails] = useState(true)
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography className={classes.sectionTitle}>
          {getTranslate('Amount Details')}
        </Typography>
        <IconButton
          className={classes.iconButton}
          onClick={() => {
            setShowDetails(!showDetails)
          }}>
          {showDetails ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
        </IconButton>
      </div>
      <Collapse in={showDetails}>
        <Divider />
        {isMobile ? (
          <div className={classes.scrollWrapper}>
            <div className={classes.scrollRow}>
              <div className={classes.content}>
                <RoomStayPriceDetails
                  roomsPriceDetails={roomsPriceDetails || []}
                  curruncy={curruncy}
                />
                {/* <TaxAndFeeDetails /> */}
              </div>
            </div>
          </div>
        ) : (
          <div className={classes.content}>
            <RoomStayPriceDetails
              roomsPriceDetails={roomsPriceDetails || []}
              curruncy={curruncy}
            />
            {/* <TaxAndFeeDetails /> */}
          </div>
        )}
      </Collapse>
      <Divider />
    </div>
  )
}

export default AmountDetails
